import { useParams } from 'react-router-dom'
import { useVideoEmbed } from 'src/hook/useVideoEmbed'
import { YouTubePlayer } from 'src/components'
import { PostModalLinkPreview } from 'src/pages/CommunityDetails/PostModalPublication/components/postModalLinkPreview'
import { PostImage } from '../postImage'
import { PathParams, PostUrlProps } from './postUrl.types'

const PostUrl = ({ post, aspectRatio, isEdit = false }: PostUrlProps) => {
  const { lang } = useParams<PathParams>()
  const { youTube } = useVideoEmbed()

  if (youTube.isValidURL(post?.description)) {
    const videoId = youTube.extractVideoId(post?.description) as string

    return <YouTubePlayer id={videoId} rel={0} showinfo={0} hl={lang} />
  }

  if (isEdit) {
    return <PostModalLinkPreview className="_mb-4" linkUrl={post.link as string} />
  }

  return (
    <>
      <PostImage post={post} aspectRatio={aspectRatio} />
      <footer data-test="footer-url" className="_bg-gray-100 _text-decoration-none _px-3 _py-2">
        <span className="_text-gray-900 _text-4 _font-weight-bold _d-block">{post.content}</span>
        <span className="_text-gray-600 _text-truncate _d-block">{post.link}</span>
      </footer>
    </>
  )
}

export default PostUrl
